import React, { useContext, useEffect, useState } from 'react'
import MassTickets from './MassTickets';
import MassDevices from './MassDevices';
import MassUsers from './MassUsers';
import MassTechnician from './MassTechnician';
import MassIncomingBatch from './MassIncomingBatch';
import MassBillingBatch from './MassBillingBatch';
import ReactDatePicker from 'react-datepicker';
import { GetAllSchoolsByLocation, HideLoder, ShowLoder, userTimeZone } from '../../JS/Common';
import AllRocketAccounts from './AllRocketAccounts';
import AllRocketUsers from './AllRocketUsers';
import AllHelpdeskTickets from './AllHelpdeskTickets';
import SchoolPurchases from './SchoolPurchases';
import ClubPurchases from './ClubPurchases';
import VendorTickets from './VendorTickets';
import PartsOrderReport from './PartsOrderReport';
import useConfig from '../../Hooks/useConfig';
import AllShieldDevices from './AllShieldDevices';

export default function MassDownload() {
    const { organization, show_schoolPurchases, show_clubPurchases, show_part_order_module } = useConfig();
    const today = new Date(
        new Date().toLocaleString("en-US", { timeZone: userTimeZone })
    );

    const oneMonthAgo = new Date(today);

    oneMonthAgo.setDate(1);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const day = today.getDate();

    const lastDayOfPreviousMonth = new Date(
        oneMonthAgo.getFullYear(),
        oneMonthAgo.getMonth() + 1,
        0
    ).getDate();

    oneMonthAgo.setDate(
        Math.min(day, lastDayOfPreviousMonth)
    );
    const [loading, setLoading] = useState(false);
    const [alerts, setalerts] = useState("");
    const [Locations, setLocations] = useState([]);
    const [Schools, setSchools] = useState([]);
    const [downloadAllChecked, setDownloadAllChecked] = useState(false);
    const [FilterData, setFilterData] = useState({
        StartDate: oneMonthAgo,
        EndDate: today,
        Location: null,
        School: null
    })
    useEffect(() => {
        GetAllSchoolsByLocation({ setLocations, setAllSchool: setSchools });
    }, []);
    function handleStartDateChange(date) {
        setFilterData((prevdata) => ({ ...prevdata, StartDate: date }));
    };
    function handleEndDateChange(date) {
        setFilterData((prevdata) => ({ ...prevdata, EndDate: date }));
    };
    const handleLocationValue = (val) => {
        setFilterData((prevdata) => ({ ...prevdata, Location: val == "0" ? null : val }));
        if (val == "0") {
            GetAllSchoolsByLocation({ setLocations, setAllSchool: setSchools });
        } else {
            var filterSchoolByLocation = Locations?.filter((data) => data?.id == val)
            setSchools(filterSchoolByLocation[0]?.school)
        }
    }
    return (
        <div>
            {alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row col-12 pe-0 align-items-center pb-3'>
                <div className='col-md-4'>
                    <h1 className="PageHeading">Bulk Reports Download</h1>
                </div>
                <div className="col-md-4 text-end row px-0">
                    <div className="col-md-6 d-flex  align-items-center py-2 px-0">
                        <label className="px-3"></label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={FilterData.StartDate}
                            onChange={(e) => { handleStartDateChange(e); }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                    <div className="col-md-6 d-flex  align-items-center py-2 px-0">
                        <label className="px-3">To</label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={FilterData.EndDate}
                            onChange={(e) => { handleEndDateChange(e); }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                </div>
                <div className="col-md-2 ms-2 py-1 pe-0">
                    <select value={FilterData.Location || "0"}
                        onChange={(e) => {
                            const val = e.target.value;
                            setLoading(true);
                            setTimeout(() => {
                                handleLocationValue(val);
                                setLoading(false);
                            }, 300);
                        }}>
                        <option value="0">Filter by Location</option>
                        {Locations.map((locationItem, j) => (
                            <option value={locationItem.id} key={j}>
                                {locationItem.location_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2 ms-2 py-1 pe-0">
                    <select value={FilterData.School}
                        onChange={(e) => {
                            const val = e.target.value;
                            setLoading(true);
                            setTimeout(() => {
                                setFilterData((prevdata) => ({ ...prevdata, School: val == 0 ? null : val }))
                                setLoading(false);
                            }, 300);
                        }}
                    >
                        <option value="0">Filter by {organization}</option>
                        {Schools?.length == 0 && <optgroup label={`No ${organization} found`}></optgroup>}
                        {Schools?.map((item, j) => (
                            <option value={item.id} key={j}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='col-12 my-1 text-end'>
                    <input type="checkbox" className="form-check-input me-2" name="downloadall"
                        defaultChecked={downloadAllChecked} onChange={(e) => setDownloadAllChecked(e.target.checked)} />
                    <label>Download All Data</label>
                </div>
            </div>
            <div className="GridBox p-4">
                <div className='row'>
                    <div className='col-md-6'>
                        <MassTickets setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6'>
                        <MassDevices setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <MassUsers setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <MassTechnician setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <MassIncomingBatch setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <MassBillingBatch setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <AllRocketAccounts setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <AllRocketUsers setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    <div className='col-md-6 mt-3'>
                        <AllHelpdeskTickets setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    {show_schoolPurchases && (
                        <div className='col-md-6 mt-3'>
                            <SchoolPurchases setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                        </div>
                    )}
                    {show_clubPurchases && (
                        <div className='col-md-6 mt-3'>
                            <ClubPurchases setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                        </div>
                    )}
                    <div className='col-md-6 mt-3'>
                        <VendorTickets setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                    {show_part_order_module &&
                        <div className='col-md-6 mt-3'>
                            <PartsOrderReport setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                        </div>
                    }
                    <div className='col-md-6 mt-3'>
                        <AllShieldDevices setLoading={setLoading} FilterData={FilterData} setalerts={setalerts} downloadAllChecked={downloadAllChecked} />
                    </div>
                </div>
            </div>
        </div>
    )
}
